/**
 * TODO
 * WIP
 */
import React from 'react';

import { css } from '@emotion/css';
import { Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';

export type SvgDataListTooltipProps = {
  children: React.ReactNode[];
};

export const SvgDataListTooltip: React.FC<SvgDataListTooltipProps> = ({
  children,
}) => {
  const styles = useStyles(makeStyles);

  return <div className={styles.container}>{children}</div>;
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    padding: ${theme.spacing(0, 8)};

    > * {
      padding: 0;
    }
    > *:not(:last-child) {
      padding-bottom: ${theme.spacing(4)};
      border-bottom: 1px solid ${theme.palette.divider};
    }
  `,
});
